// extracted by mini-css-extract-plugin
export default {"content":"mainArea_content__vdsAb","buttons":"mainArea_buttons__9bMBP","wrapper":"mainArea_wrapper__bHnGf"};